import api from "./baseApi";
import endpoints from "./endpoints";

export const sendReceiptEmail = async (receiptId) => {
  const res = await api.post(
    endpoints.receipts.sendEmail(receiptId)
  );
  return res.data;
};